import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-radio-button',
  templateUrl: './ab-radio-button.component.html',
  styleUrls: ['./ab-radio-button.component.scss']
})
export class AbRadioButtonComponent implements OnInit {

 @Input() element: any;
  constructor() { }

  ngOnInit(): void {
  }

}
